import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import { toString as productToString } from 'utils/pivot/product'
import toggleClass from 'utils/DOM/toggleClass'
import { isArray } from '@hc-frontend/utils'
import innerHTML from 'utils/DOM/innerHTML'
import getById from 'utils/DOM/getById'
import { ECONOMY, CHOICE, STANDARD, DELUXE, CORE, QUANTUM } from 'core/constants/products'

const shortDescription = {
  [ECONOMY]: 'Basic, budget-friendly',
  [CHOICE]: 'Doctor & urgent care copay',
  [STANDARD]: 'Lower deductibles & Rx copays',
  [DELUXE]: 'Maximum out-of-pocket benefits',
  [CORE]: 'Plans for everyday care',
  [QUANTUM]: 'Access to one of the nation’s largest PPO networks.'
}

function renderSummary(durationsByProduct) {
  const typeData = Object.keys(durationsByProduct)

  if (isArray(typeData) && typeData.length > 0) {
    const typeOrder = [ECONOMY, CHOICE, STANDARD, DELUXE]

    typeData.sort((a, b) => {
      let idxOfA = typeOrder.indexOf(+a)
      let idxOfB = typeOrder.indexOf(+b)

      if (idxOfA === -1) {
        idxOfA = typeOrder.length
      }

      if (idxOfB === -1) {
        idxOfB = typeOrder.length
      }

      if (idxOfA > idxOfB) {
        return 1
      } else {
        return -1
      }
    })

    const templatePlans = Templater(getById('template-summary-plan').innerText)
    innerHTML(
      '#summary-plans',
      typeData
        .map(planId => {
          const description = shortDescription[planId]
          const plan = {
            description,
            type: productToString(planId)
          }
          return description ? templatePlans(plan) : ''
        })
        .join('')
    )
    toggleClass(document.getElementById('summary'), 'd-lg-block', true)
  }
}

export default renderSummary
